<!-- <div class="repeat-section-container"> -->
<!-- <h5>Numero di scale: {{ field.fieldGroup.length }}</h5> -->
<div class="section-repeat" *ngFor="let subField of field.fieldGroup; let i = index">
  <formly-field [field]="subField"></formly-field>
</div> <!-- /.section-repeat -->
<button mat-raised-button color="primary" (click)="onAddRow()">
  <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
  {{ 'common.words.add' | translate }}
</button>
<!-- </div> -->